<script setup lang="ts">
defineProps<{
  title: string
}>()
</script>

<template>
  <Card>
    <CardHeader class="flex flex-row items-center justify-between">
      <CardTitle>{{ title }}</CardTitle>
      <slot name="title-actions" />
    </CardHeader>
    <CardContent class="space-y-6">
      <slot />
    </CardContent>
  </Card>
</template>
